export const DotsProgress = () => {
  return (
    <div className="flex gap-0.5">
      <div className="size-1 bg-base-5 rounded animate-[pulse_.6s_infinite]" />
      <div className="size-1 bg-base-5 rounded animate-[pulse_.6s_infinite_.2s]" />
      <div className="size-1 bg-base-5 rounded animate-[pulse_.6s_infinite_.4s]" />
    </div>
  );
};
